import {Component} from '@angular/core';

@Component({
    selector: 'app-root',
    template: `
    <app-toast/>
    <router-outlet></router-outlet>
  `,
    standalone: false
})
export class AppComponent {
}

